
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IBankAccountNumbers } from '../../../../FinancialInformation/models/models'

export class BankAccountListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/bankAccount/getBankAccounts',
      requesterInfo,
    })
  }

  public async listBankAccount(): Promise<IBankAccountNumbers[]> {
    return await this.getAsync<IBankAccountNumbers[]>()
  }
}
